module.exports = __webpack_public_path__ + "cancellara-live-dist/img/promo-left.4a8a2776.png";